import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import { IClientUID } from '../clients'

export interface ICustomerData {
    name: string
    address: string
    city: string
    telephone: string
    cellphone1: string
    cellphone2: string
    mail: string
    company: string
    notes: string
    key: string
}

export enum CustomerDataType {
    name = 0,
    address = 1,
    city = 2,
    telephone = 3,
    cellphone1 = 4,
    cellphone2 = 5,
    mail = 6,
    company = 7,
    notes = 8,
    key = 9,
}

export interface ICustomerDataUpdate {
    type: CustomerDataType
    value: string
}

export async function getClientCustomerData(clientId: IClientUID): Promise<ApiResponse<ICustomerData>> {
    const response = await fetch(`${HOST_URL}0x0005/customer-data`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<ICustomerData>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function updateClientCustomerData(clientId: IClientUID, updates: ICustomerDataUpdate[]): Promise<ApiResponse<null>> {
    const response = await fetch(`${HOST_URL}0x0005/customer-data`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, updates }),
    })
    const result = (await response.json()) as ApiResponse<null>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
